import LoginComponent from '../../components/LoginComponent';
import { PROVIDER_NAME, PROVIDER_KEY } from '../../constants';
export default function getAbacusAuthProvider() {
  function getAutoLoginData({
    ctx
  }) {
    if (!ctx || !ctx.disableSsr) return null;
    return {};
  }
  return {
    name: PROVIDER_NAME,
    key: PROVIDER_KEY,
    LoginComponent,
    getAutoLoginData
  };
}
//# sourceMappingURL=get-abacus-auth-provider.js.map